import { QUERY_DELETE_SERVICE, QUERY_GET_SERVICES, QUERY_GET_SERVICES_ADMIN, QUERY_GET_SERVICES_USER, QUERY_POST_CREATE_SERVICE, QUERY_PUT_UPDATE_SERVICE } from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const getServices = baseThunk("services", QUERY_GET_SERVICES, "GET")
export const getUserServices = baseThunk("services/users", QUERY_GET_SERVICES_USER, "GET")

export const getServicesAdmin = baseThunk("services/admin", QUERY_GET_SERVICES_ADMIN, "GET")
export const createService = baseThunk("services/create", QUERY_POST_CREATE_SERVICE, "POST")
export const editService = baseThunk("services/edit", QUERY_PUT_UPDATE_SERVICE, "PUT")
export const deleteService = baseThunk("services/delete", QUERY_DELETE_SERVICE, "DELETE")
